import Ajax from "Utils/ajax";
export const getApplicationList = (data) => Ajax.post('career/getApplicationList',data); 
export const addUpdateApplication = (data) => Ajax.post('career/addUpdateApplication',data); 
export const getApplicationStatus = (data) => Ajax.post('career/getApplicationStatus',data); 
export const removeRow = (data) => Ajax.post('career/removeApplication',data); 
export const resumeUploads = (data) => Ajax.post('career/resumeUploads',data); 